import { PaginationData } from './_';

export enum UserRoleEnums {
  CUSTOMER = 'CUSTOMER',
  OFFICIAL = 'OFFICIAL',
  CONTENT_PROVIDER = 'CONTENT_PROVIDER',
  MERCHANT = 'MERCHANT',
  HKTV_SHOPS_MERCHANT = 'HKTV_SHOPS_MERCHANT',
  YOUTUBER = 'YOUTUBER',
  STREAMER = 'STREAMER',
}

export const roleOptions = [
  { value: "ALL", label: '全部' },
  { value: UserRoleEnums.OFFICIAL, label: '官方賬戶' },
  { value: UserRoleEnums.CONTENT_PROVIDER, label: '評測員' },
  { value: UserRoleEnums.MERCHANT, label: 'HKTVmall商戶' },
  { value: UserRoleEnums.HKTV_SHOPS_MERCHANT, label: 'HKTVshops商戶' },
  { value: UserRoleEnums.YOUTUBER, label: '內容創作者' },
  { value: UserRoleEnums.STREAMER, label: '直播主持' },
  { value: UserRoleEnums.CUSTOMER, label: '客戶'}
];

export const membershipLevelOptions = [
  { value: 'NORMAL', label: 'NORMAL' },
  { value: 'VIP', label: 'VIP' },
  { value: 'GOLDVIP', label: 'GOLDVIP'},
  { value: 'DIAMONDVIP', label: 'DIAMONDVIP'},
];

interface UserRoleRadioOptionsProps {
  userPk: string;
  setUserRoleForm?: (radioValue: any) => void;
  userRole: UserRoleEnums;
}

interface FetchUserRoleParam {
  params: fetchUserRoleParam;
}

interface PutUserRoleParam {
  uuid: string;
  kocUserRole: string;
}

interface fetchUserRoleParam {
  role?: string;
  userUuid?: string;
  page_no?: number;
  page_size?: number;
}

interface UserRoleData {
  uuid: string;
  hybrisId: string;
  name: string;
  membershipLevel: string;
  profileIconUrl: string;
  kocUserRole: string;
  pagination: PaginationData;
}

interface SnsPlatform {
  platformType: 'FACEBOOK' | 'INSTAGRAM' | 'YOUTUBE';
  handleOrUrl: string;
  crawlActive: boolean;
}

interface UpdateStreamDataRequest {
  uuid: string;
  name: string | null;
  description?: string | null;
  banner?: File;
  isBannerDelete?: boolean;
  snsPlatforms?: SnsPlatform[];
}

interface UpdateMyPageDataRequest {
  uuid: string;
  profileID?: string | null;
  name: string | null;
  description?: string | null;
  profileIconId?: string | null;
  profileIconUrl?: string | null;
}

// eslint-disable-next-line import/prefer-default-export
export type {
  FetchUserRoleParam,
  UserRoleData,
  UserRoleRadioOptionsProps,
  PutUserRoleParam,
  UpdateStreamDataRequest,
  UpdateMyPageDataRequest,
  SnsPlatform,
};
